// extracted by mini-css-extract-plugin
export var notificationHost = "_cg-0";